import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdService } from 'src/app/shared/services/ad.service';
import { AdType } from 'src/app/shared/models/ad';


import { AdController } from 'src/app/shared/components/ad-controller/ad-controller';
import { FormBuilder } from '@angular/forms';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { AddressService } from 'src/app/shared/services/address.service';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { MatSelectChange } from '@angular/material/select';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogActionComponent } from 'src/app/shared/components/dialog-action/dialog-action.component';
import { deepCopy } from '@angular-devkit/core/src/utils/object';


declare var $:any;

@Component({
    selector: 'app-available',
    templateUrl: './available.component.html',
    styleUrls: ['./available.component.scss','../../../../shared/components/ad/ad-tableunits.scss']
})
export class AvailableComponent extends AdController implements OnInit {

    dialogRef:MatDialogRef<any>;
    data:any = [];
    adData:any = {};
    id: any;

    openingUnitAmount = false;
    
    
    typeSettingsDefine:any = {};
    blockSelected;
    blockData:any = {};

    unitStatus:any = [];
    unitStatusArray:any = [];

    changed = false;

    unitSelected;

    formGroupUnit = this.formBuilder.group({
        id :[''], 
        title: [''],
        blockTypeId :[''], 
        amountIndex :[''], 
        amountOld :[''], 
        amount :[''], 
        resale :[false], 
        preReserved :[false], 
        observation :[''], 
        status :['']
      });

    constructor(formBuilder: FormBuilder,
        
        logger: LoggerService,
        adService: AdService,
        gs: GeneralService,
        activatedRoute: ActivatedRoute,
        router: Router,
        public adUtils : AdUtils,
        snackBarService: SnackBarService,
        addressService: AddressService,
        protected als : AppLoadingService,
        public dialog: MatDialog
      ) {
        super(formBuilder, logger, adService, gs, activatedRoute, router, snackBarService, addressService, als, dialog);
        this.als.setLoaded(false,this.gs.getBase()+'AdAvaiable');
    }

    load(){}
    subscribeOnChangeExtra(){}
    updateControls(){}
    updateObject(){}
    setDefault(){}

    ngOnInit() {

        this.adService.loadAd(this.id, this.gs.getCompanieSel()).then(result => {
            this.adData = result;
            this.data = this.adData?.data;
            this.blocksDS = this.data.blocks;
            this.unitTypesDS = this.data.unitTypes;
            this.unitsDS = this.data.units;
            
            
            let category = this.gs.getFeatureCategory(this.adData.ad_category_id);
            let adType =  this.adService.getFeatureTypes(category?.type_id)?.type;
            this.unitStatus = this.gs.getStatus('unit', adType);
            this.unitStatusArray = this.gs.arrayKeyCustom(this.gs.getStatus('unit', adType), 'id');
            this.typeSettingsDefine = new AdType().getType(adType);
            
            if(this.typeSettingsDefine.multipleUnits){
                this.setUnitsByFloor();
                this.setBlockSelected(this.data.blocks[0]?.id);
            } else {
                this.setUnitSelected(this.unitsDS[0]);
            }
             
            this.als.setLoaded(true,this.gs.getBase()+'AdAvaiable');    

        });

    }

    setBlockSelected(id){
        if(id instanceof MatSelectChange)
            id = id.value;

        if(this.formGroupUnit.dirty)
            return this.openDialog({params: id, action:'blockChange'});

        this.blockData = this.data.blocks.filter(item => item.id == id)[0];
        this.blockSelected = id;
        this.unitSelected = null;

        setTimeout(()=>
        $('.tableUnits [data-toggle="tooltip"]').tooltip({
            trigger : 'hover'
        }), 200);

        
    }

    setUnitSelected(datai){

        let data = deepCopy(datai);
        console.log(data);
        if(this.formGroupUnit.dirty)
            return this.openDialog({params: data, action:'unitChange'});

        if(!data?.resale && this.typeSettingsDefine?.multipleUnits)
            data.resale = false;

        if(!data?.preReserved && this.typeSettingsDefine?.multipleUnits)
            data.preReserved = false;
            
        if(data?.amount){
            if(typeof data?.amount !== 'string')
                data.amount = data.amount.toString();

            data.amount = data.amount?.indexOf('.') == -1? data.amount+',00' : data.amount.replace('.',',');
        }

        if(data?.amountOld){
            if(typeof data?.amountOld !== 'string')
                data.amountOld = data.amountOld.toString();

            data.amountOld = data.amountOld?.indexOf('.') == -1? data.amountOld+',00' : data.amountOld.replace('.',',');
        }

        if(data?.amountIndex){
            if(typeof data?.amountIndex !== 'string')
                data.amountIndex = data.amountIndex.toString();

            data.amountIndex = data.amountIndex?.indexOf('.') == -1? data.amountIndex+',000000' : data.amountIndex.replace('.',',');
        }

        if(!data?.observation)
            data.observation = '';

        this.setFormValues(data,this.formGroupUnit);
        this.formGroupUnit.markAsPristine();
        this.unitSelected = data;
    }

    closeDialog(){
        if(this.changed || this.formGroupUnit.dirty)
            this.openDialog({action:'close'});
        else
            this.dialogRef.close();
    }

    openDialog(data){
        const dialogRef = this.dialog.open(DialogActionComponent, 
            {disableClose : true,
             data: {
                title:'Deseja salvar as alterações?',
                cancelTitle:'Descartar',
                okTitle:'Salvar'
            }});

        dialogRef.afterClosed().subscribe(result => {
            if(data.action == 'unitChange' || data.action == 'blockChange'){
                if(result)
                    this.saveUnit();

                this.unitSelected = null;
                this.formGroupUnit.reset();

                if(data.action == 'unitChange')
                    this.setUnitSelected(data.params);

                else if(data.action == 'blockChange')
                    this.setBlockSelected(data.params);

                this.openUnitAmount();

                return;
            }
            
            this.saveAvailable(result);

        });
    }

    saveUnit(){
        this.changed = true;

        let newData = this.getFormValues(this.formGroupUnit);
        newData.changed = true;

        this.unitsDS = this.unitsDS.map(item => {
            if(item.id == newData.id)
                item = newData;

            return item;
        });
        this.setUnitsByFloor();

        this.unitSelected = null;
        this.formGroupUnit.reset();
    }
    saveAvailable(save){
        if(this.formGroupUnit.dirty)
            this.saveUnit();

        if(save){
            let units = JSON.parse(JSON.stringify(this.unitsDS))
                            .filter(item => item.changed)
                            .map(item => { 
                                Object.keys(item).filter(k => { 
                                    if(['id','amount','amountOld','amountIndex','resale','preReserved','status','observation'].indexOf(k) == -1)
                                        delete item[k]; 
                                });
                                return item;
                            });

            return this.save('updateUnits', {
                ad_id : this.adData.ad_id,
                update : this.adData.update,
                units : units
            },result => {
                this.snackBarService.open('Disponibilidade atualizada com sucesso.');
                this.gs.transactionData.next({method:'adUpdated', action:'reload'});
                this.dialogRef.close();
                this.openUnitAmount();
            });            
        }

        this.dialogRef.close();
        this.openUnitAmount();
    }

    unitAmount(){
        this.openingUnitAmount = true;
        if(this.changed || this.formGroupUnit.dirty)
            this.openDialog({action:'close'});
        else
            this.openUnitAmount();
    }

    openUnitAmount(){
        if(this.openingUnitAmount)
            this.gs.navigate(['openModal', 'UnitAmountComponent', this.adData.ad_id]);
    }

}
